import type { FunctionComponent, PropsWithChildren } from 'react';
import { useMemo } from 'react';
import type { PcaMapState } from './PcaMapContext';
import { PcaMapContext } from './PcaMapContext';
import { usePcaMap } from '../../app-kit/components/PcaMap/usePcaMap';
import { MarkerFactory, OnMapLoaded } from '../../app-kit/components/PcaMap/PcaMap';
import { getEnv } from '../../helpers/getEnv';

export interface PcaMapContextProviderProps extends google.maps.MapOptions {
  apiKey?: string;
  markerFactories?: ReadonlyArray<MarkerFactory>;
  onMapLoaded?: OnMapLoaded | null;
  outboundLinkType: string; // E.g. google-map-link-to-property-location
}

export const PcaMapContextProvider: FunctionComponent<
  PropsWithChildren<PcaMapContextProviderProps>
> = ({ children, ...pcaMapConfig }) => {
  const apiKey = pcaMapConfig?.apiKey ?? getEnv.GOOGLE_MAPS_API_KEY();
  const pcaMapConfigWithDefaultCenter: Readonly<typeof pcaMapConfig> = {
    ...pcaMapConfig,
  };
  const initialState = usePcaMap(apiKey, pcaMapConfigWithDefaultCenter);
  const pcaMapContext = useMemo<PcaMapState>(
    () => ({
      ...initialState,
      initialConfig: pcaMapConfigWithDefaultCenter,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [initialState.isLoading],
  );
  return <PcaMapContext.Provider value={pcaMapContext}>{children}</PcaMapContext.Provider>;
};
